import { Component, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Platform } from '@model/platform.model';

import { LoginService } from '@util/login.service';
import { PlatformService } from '@util/platform.service';
import {
  LoggerService,
  LOG_LEVEL,
} from '@app/services/util/logger.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

/**
 * NavbarComponent
 *
 * @export NavbarComponent
 */
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  closeResult: string;

  /**
   * The id of the selected platform
   */
  platformId: string;

  /**
   * boolean check for login
   */
  isLoggedIn = false;

  /**
   * Array of platforms for dropdown list
   */
  platforms: Array<Platform>;

  /**
   * Logged in user details for settings dropdown list
   */
  user: any;

  /**
   * Current page in router
   */
  currentPage: string;

  /**
   * Creates an instance of NavbarComponent.
   *
   * @param router used to navigate routes
   * @param loginService used to check login
   * @param platfromService used to get PetSafe platforms
   */
  constructor(
    private router: Router,
    private loginService: LoginService,
    private platfromService: PlatformService,
    private modalService: NgbModal,
  ) {
    this.router.events.forEach(event => {
      if (event instanceof NavigationStart) {
        this.loginService.checkLogin().subscribe(
          data => {
            this.isLoggedIn = data;
            if (this.isLoggedIn) {
              if (!this.user) {
                this.loginService.getUser().then(res => {
                  this.user = res;
                });
              }
            }
          },
          error => {
            LoggerService.log(error, LOG_LEVEL.ERROR);
          },
        );
        this.currentPage = event.url;
      }
    });
  }

  /**
   * Initialise platforms
   */
  ngOnInit() {
    this.platforms = this.platfromService.getPlatforms();
  }

  /**
   * Log the current user out
   */
  logout(): void {
    this.loginService.logout();
  }

  /**
   * Checks to see if the value passed in matches the current page URL
   *
   * @param val string to check
   * @returns returns true if the value matches the current page
   */
  checkPage(val: string): boolean {
    if (val === '/platform') {
      return this.currentPage.includes(val);
    } else {
      return val === this.currentPage;
    }
  }

  open(content) {
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        result => {
          this.closeResult = `Closed with: ${result}`;
        },
        reason => {
          this.closeResult = `Dismissed ${this.getDismissReason(
            reason,
          )}`;
        },
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
